if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText =
          this.submitButton.querySelector('.product-form__button-text') || this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = evt.submitter || this.submitButton;
        const submitButtonText = submitButton.querySelector('.product-form__button-text') || submitButton.querySelector('span');
        const submitButtonSpinner = submitButton.querySelector('.loading__spinner') || this.querySelector('.loading__spinner');
        const directCheckout = submitButton.hasAttribute('data-direct-checkout');
        const checkoutUrl = window.routes.checkout_url || '/checkout';

        if (submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        submitButtonSpinner?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const bundleSelector =
          this.dataset.ignoreBundle === 'true'
            ? undefined
            : this.closest('product-info')?.querySelector('bundle-pack-selector');

        if (bundleSelector && bundleSelector.getSelectedPack?.() === '2') {
          const items = bundleSelector.getSelectedItems?.() || [];
          if (items.length > 0) {
            fetch(`${routes.cart_add_url}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({ items }),
            })
              .then((response) => response.json())
              .then((response) => {
                if (response.status) {
                  this.handleErrorMessage(response.description || response.message);
                  return;
                }
                window.location = directCheckout ? checkoutUrl : window.routes.cart_url;
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('aria-disabled');
                submitButtonSpinner?.classList.add('hidden');
              });
            return;
          }
        }
        if (this.cart && !directCheckout) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (!config.body) config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              submitButton.setAttribute('aria-disabled', true);
              submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (directCheckout) {
              window.location = checkoutUrl;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) submitButton.removeAttribute('aria-disabled');
            submitButtonSpinner?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.querySelectorAll('[type="submit"]').forEach((button) => {
          const buttonText = button.querySelector('.product-form__button-text') || button.querySelector('span');
          if (buttonText && !button.dataset.defaultText) button.dataset.defaultText = buttonText.textContent.trim();

          if (disable) {
            button.setAttribute('disabled', 'disabled');
            if (text && buttonText) buttonText.textContent = text;
            return;
          }

          button.removeAttribute('disabled');
          if (!buttonText) return;
          buttonText.textContent = button.hasAttribute('data-direct-checkout')
            ? button.dataset.defaultText
            : window.variantStrings.addToCart;
        });
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      constructor() {
        super();
        this.productInfo = undefined;
        this.button = this.querySelector('[data-sticky-atc-button]');
        this.buttonText = this.querySelector('[data-sticky-atc-button-text]');
        this.price = this.querySelector('[data-sticky-atc-price]');
        this.options = this.querySelector('[data-sticky-atc-options]');
        this.image = this.querySelector('.product-sticky-atc__image');
        this.variantChangeUnsubscriber = undefined;
        this.mainButtonObserver = undefined;
        this.movedToBody = false;
        this.boundButtonClick = this.onButtonClick.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.productInfo || this.closest('product-info');
        if (!this.movedToBody) {
          const existingStickyAtc = document.body.querySelector(
            `product-sticky-atc[data-section-id="${this.dataset.sectionId}"]`
          );
          if (existingStickyAtc && existingStickyAtc !== this) existingStickyAtc.remove();
          this.movedToBody = true;
          document.body.appendChild(this);
          return;
        }

        document.body.classList.add('has-product-sticky-atc');
        this.button?.addEventListener('click', this.boundButtonClick);
        this.variantChangeUnsubscriber = this.subscribeToVariantChange();
        this.observeMainButton();
        this.syncButtonState();
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.boundButtonClick);
        this.variantChangeUnsubscriber?.();
        this.mainButtonObserver?.disconnect();
        if (!document.querySelector('product-sticky-atc')) {
          document.body.classList.remove('has-product-sticky-atc');
        }
      }

      onButtonClick() {
        const mainButton = this.getMainButton();
        if (!mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') return;
        mainButton.click();
      }

      subscribeToVariantChange() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return undefined;
        return subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!this.shouldHandleVariantChange(data)) return;
          this.updateVariant(data.variant);
          window.setTimeout(() => this.syncButtonState(), 0);
        });
      }

      shouldHandleVariantChange(data) {
        if (!data?.variant) return false;
        const currentSectionId = this.productInfo?.dataset.section || this.dataset.sectionId;
        return !data.sectionId || !currentSectionId || data.sectionId === currentSectionId;
      }

      updateVariant(variant) {
        if (this.price) this.price.textContent = this.formatMoney(variant.price);
        if (this.options && Array.isArray(variant.options)) this.options.textContent = variant.options.join(' / ');

        const imageUrl =
          variant.featured_media?.preview_image?.src ||
          variant.featured_media?.preview_image?.url ||
          variant.featured_image?.src ||
          variant.featured_image?.url;
        if (imageUrl && this.image) {
          this.image.removeAttribute('srcset');
          this.image.src = imageUrl;
        }
      }

      observeMainButton() {
        const mainButton = this.getMainButton();
        if (!mainButton || typeof MutationObserver === 'undefined') return;
        this.mainButtonObserver?.disconnect();
        this.mainButtonObserver = new MutationObserver(() => this.syncButtonState());
        this.mainButtonObserver.observe(mainButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled', 'class'],
          childList: true,
          subtree: true,
        });
      }

      syncButtonState() {
        const mainButton = this.getMainButton();
        if (!mainButton || !this.button) return;
        const disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
        this.button.disabled = disabled;
        this.button.classList.toggle('loading', mainButton.classList.contains('loading'));

        const mainText = mainButton.querySelector('.product-form__button-text')?.textContent?.trim();
        if (mainText && this.buttonText) this.buttonText.textContent = mainText;
      }

      getMainButton() {
        return (
          document.getElementById(`ProductSubmitButton-${this.dataset.sectionId}`) ||
          this.productInfo?.querySelector('.product-form__submit')
        );
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;
        const currency = this.dataset.currencyCode || 'USD';
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
        } catch (_) {
          return `$${amount.toFixed(2)}`;
        }
      }
    }
  );
}

if (!customElements.get('bundle-pack-selector')) {
  customElements.define(
    'bundle-pack-selector',
    class BundlePackSelector extends HTMLElement {
      constructor() {
        super();
        this.variants = this.getVariants();
        this.packInputs = this.querySelectorAll('[data-bundle-pack-input]');
        this.rows = this.querySelector('[data-bundle-rows]');
        this.countdownElement = this.querySelector('[data-bundle-countdown]');
        this.currentVariant = this.getInitialVariant();
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        this.packInputs.forEach((input) => input.addEventListener('change', this.onPackChange.bind(this)));
        this.querySelectorAll('[data-bundle-option]').forEach((select) =>
          select.addEventListener('change', this.onOptionChange.bind(this))
        );
        this.variantChangeUnsubscriber = this.subscribeToVariantChange();
        this.syncRowsToVariant(this.currentVariant);
        this.updateRowsVisibility();
        this.updateRowMedia();
        this.updateSaveBadges();
        this.startCountdown();
      }

      disconnectedCallback() {
        if (this.countdownInterval) window.clearInterval(this.countdownInterval);
        this.variantChangeUnsubscriber?.();
      }

      getVariants() {
        const script = this.querySelector('[data-bundle-variants]');
        if (!script) return [];
        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error('Unable to parse bundle variants', error);
          return [];
        }
      }

      getInitialVariant() {
        const variantId = this.closest('product-info')?.querySelector('input[name="id"]')?.value;
        return this.variants.find((variant) => String(variant.id) === String(variantId)) || this.variants[0];
      }

      getSelectedPack() {
        return this.querySelector('[data-bundle-pack-input]:checked')?.value || '1';
      }

      getSelectedItems() {
        if (this.getSelectedPack() !== '2') return [];
        const itemMap = Array.from(this.querySelectorAll('[data-bundle-row]'))
          .map((row) => this.getVariantForRow(row))
          .filter(Boolean)
          .reduce((items, variant) => {
            items.set(variant.id, (items.get(variant.id) || 0) + 1);
            return items;
          }, new Map());
        return Array.from(itemMap, ([id, quantity]) => ({ id, quantity }));
      }

      onPackChange() {
        this.updateRowsVisibility();
        this.updateSaveBadges();
      }

      onOptionChange() {
        this.updateRowMedia();
        this.updateSaveBadges();
      }

      subscribeToVariantChange() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return undefined;
        return subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!this.shouldHandleVariantChange(data)) return;
          this.currentVariant = this.variants.find((variant) => String(variant.id) === String(data.variant?.id)) || data.variant;
          this.syncRowsToVariant(this.currentVariant);
          this.updateRowMedia();
          this.updateSaveBadges();
        });
      }

      shouldHandleVariantChange(data) {
        if (!data?.variant) return false;
        const productInfo = this.closest('product-info');
        const currentSectionId = productInfo?.dataset.section || this.dataset.sectionId;
        return !data.sectionId || !currentSectionId || data.sectionId === currentSectionId;
      }

      syncRowsToVariant(variant) {
        if (!variant?.options?.length) return;
        this.querySelectorAll('[data-bundle-row]').forEach((row) => {
          row.querySelectorAll('[data-bundle-option]').forEach((select) => {
            const optionIndex = Number(select.dataset.optionPosition || 1) - 1;
            const optionValue = variant.options[optionIndex];
            if (optionValue != null && select.value !== optionValue) {
              select.value = optionValue;
            }
          });
        });
      }

      updateRowsVisibility() {
        if (!this.rows) return;
        this.rows.hidden = this.getSelectedPack() !== '2';
      }

      updateRowMedia() {
        this.querySelectorAll('[data-bundle-row]').forEach((row) => {
          const variant = this.getVariantForRow(row);
          const image = row.querySelector('.bundle-pack__thumb img');
          if (variant?.featured_image && image) {
            image.removeAttribute('srcset');
            image.src = variant.featured_image;
          }
        });
      }

      updateSaveBadges() {
        this.updateSinglePackSaveBadge();
        this.updateTwoPackSaveBadge();
        this.updatePackPrices();
      }

      updateSinglePackSaveBadge() {
        const badge = this.querySelector('[data-bundle-save-badge="1"]');
        if (!badge || !this.currentVariant) return;
        const compareAtPrice = Number(this.currentVariant.compare_at_price || this.currentVariant.price || 0);
        const price = Number(this.currentVariant.price || 0);
        const savings = Math.max(compareAtPrice - price, 0);
        badge.textContent = this.getSaveText(savings);
      }

      updateTwoPackSaveBadge() {
        const badge = this.querySelector('[data-bundle-save-badge="2"]');
        if (!badge) return;
        const selectedVariants = Array.from(this.querySelectorAll('[data-bundle-row]'))
          .map((row) => this.getVariantForRow(row))
          .filter(Boolean);
        const savings = this.getTwoPackSavings(selectedVariants);
        badge.textContent = this.getSaveText(savings);
      }

      updatePackPrices() {
        const one = this.querySelector('[data-bundle-pack-price="1"]');
        if (one && this.currentVariant) one.textContent = this.formatMoney(this.currentVariant.price || 0);
        const two = this.querySelector('[data-bundle-pack-price="2"]');
        if (!two) return;
        const selectedVariants = Array.from(this.querySelectorAll('[data-bundle-row]'))
          .map((row) => this.getVariantForRow(row))
          .filter(Boolean);
        let total = selectedVariants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
        if (!total && this.currentVariant) total = Number(this.currentVariant.price || 0) * 2;
        const discount = this.getTwoPackExtraDiscount(total);
        two.textContent = this.formatMoney(Math.max(total - discount, 0));
      }

      getTwoPackSavings(selectedVariants) {
        const subtotal = selectedVariants.reduce((sum, variant) => sum + Number(variant.price || 0), 0);
        const compareAtSubtotal = selectedVariants.reduce((sum, variant) => {
          return sum + Number(variant.compare_at_price || variant.price || 0);
        }, 0);
        const productSavings = Math.max(compareAtSubtotal - subtotal, 0);
        const packDiscount = this.getTwoPackExtraDiscount(subtotal);
        return Math.min(productSavings + packDiscount, compareAtSubtotal);
      }

      getTwoPackExtraDiscount(subtotal) {
        const discountType = this.dataset.discountType;
        const discountValue = Number.parseFloat(this.dataset.discountValue || '0');
        if (!subtotal || !discountValue || discountType === 'none') return 0;
        if (discountType === 'percentage') return Math.round(subtotal * (discountValue / 100));
        if (discountType === 'fixed_amount') return Math.min(Math.round(discountValue * 100), subtotal);
        return 0;
      }

      getSaveText(savings) {
        const prefix = this.dataset.savePrefix || 'SAVE';
        return `${prefix} ${this.formatMoney(savings)}`;
      }

      formatMoney(cents) {
        const amount = Number(cents || 0) / 100;
        const currency = this.dataset.currencyCode || 'USD';
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount);
        } catch (_) {
          return `$${amount.toFixed(2)}`;
        }
      }

      getVariantForRow(row) {
        const selectedOptions = Array.from(row.querySelectorAll('[data-bundle-option]'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((select) => select.value);
        return this.variants.find((variant) => {
          if (!variant.available) return false;
          return variant.options.every((option, index) => option === selectedOptions[index]);
        });
      }

      startCountdown() {
        if (!this.countdownElement) return;

        const minutes = Number(this.dataset.countdownMinutes || 15);
        const duration = Math.max(minutes, 1) * 60;
        const loop = this.dataset.countdownLoop === 'true';
        const storageKey = `bundle-countdown-${this.dataset.sectionId}`;
        const now = Math.floor(Date.now() / 1000);
        let endTime = Number(sessionStorage.getItem(storageKey));

        if (!endTime || endTime <= now) {
          endTime = now + duration;
          sessionStorage.setItem(storageKey, endTime);
        }

        const tick = () => {
          const current = Math.floor(Date.now() / 1000);
          let remaining = endTime - current;

          if (remaining <= 0 && loop) {
            endTime = current + duration;
            sessionStorage.setItem(storageKey, endTime);
            remaining = duration;
          }

          remaining = Math.max(remaining, 0);
          const displayMinutes = String(Math.floor(remaining / 60)).padStart(2, '0');
          const displaySeconds = String(remaining % 60).padStart(2, '0');
          this.countdownElement.textContent = `${displayMinutes}:${displaySeconds}`;
        };

        tick();
        this.countdownInterval = window.setInterval(tick, 1000);
      }
    }
  );
}

if (!customElements.get('size-chart-modal')) {
  customElements.define(
    'size-chart-modal',
    class SizeChartModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('[data-size-chart-dialog]');
        this.onRootClick = this.onRootClick.bind(this);
        this.onDialogClick = this.onDialogClick.bind(this);
      }

      connectedCallback() {
        if (!this.dialog) return;
        this.addEventListener('click', this.onRootClick);
        this.dialog.addEventListener('click', this.onDialogClick);
      }

      disconnectedCallback() {
        if (!this.dialog) return;
        this.removeEventListener('click', this.onRootClick);
        this.dialog.removeEventListener('click', this.onDialogClick);
      }

      onRootClick(event) {
        const openButton = event.target.closest('[data-size-chart-open]');
        if (openButton && this.contains(openButton)) {
          event.preventDefault();
          this.open();
          return;
        }
        const closeButton = event.target.closest('[data-size-chart-close]');
        if (closeButton && this.contains(closeButton)) {
          event.preventDefault();
          this.close();
        }
      }

      onDialogClick(event) {
        if (event.target === this.dialog) this.close();
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        if (typeof this.dialog.showModal === 'function') {
          try {
            this.dialog.showModal();
          } catch (_) {
            this.dialog.setAttribute('open', '');
          }
        } else {
          this.dialog.setAttribute('open', '');
        }
      }

      close() {
        if (!this.dialog || !this.dialog.open) return;
        if (typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
      }
    }
  );
}

if (!customElements.get('product-upsell-carousel')) {
  customElements.define(
    'product-upsell-carousel',
    class ProductUpsellCarousel extends HTMLElement {
      constructor() {
        super();
        this.track = this.querySelector('[data-upsell-track]');
      }

      connectedCallback() {
        this.querySelectorAll('.product-upsell__arrow').forEach((button) => {
          button.addEventListener('click', this.onArrowClick.bind(this));
        });
      }

      onArrowClick(event) {
        if (!this.track) return;
        const direction = event.currentTarget.name === 'next' ? 1 : -1;
        const firstCard = this.track.querySelector('.product-upsell-card');
        const scrollAmount = firstCard ? firstCard.offsetWidth + 12 : this.track.clientWidth * 0.8;
        this.track.scrollBy({
          left: direction * scrollAmount,
          behavior: 'smooth',
        });
      }
    }
  );
}
